export default {"src":"/_next/static/media/inactive-indicator-orange.31922acf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};